import styled from 'styled-components';
import { sizes } from '../../utils/style-utils';

export const ProductNotAvailableWrapper = styled.div`
  @media (min-width: ${sizes.mobile + 1}px) {
    width: 65%;
    padding-left: 14px;
  }
`;

export const Title = styled.div`
  font-size: 4rem;
  @media (max-width: ${sizes.mobile}px) {
    font-size: 2.4rem;
  }
`;

export const ShowConfigurator = {
  visibility: 'visible',
  opacity: 1,
  transition: 'opacity 1.4s ease',
};

export const HideConfigurator = {
  visibility: 'hidden',
  opacity: 0,
  height: 0,
  width: 0,
  overflow: 'hidden',
  transition: 'opacity 1.4s ease',
};

export const AlertWrapper = styled.div`
  margin: 2rem 0 0 0;

  .sui-w-full {
    white-space: normal;
  }
`;
export const WarningAlertWrapper = styled.div`
  width: 100%;
  padding: 0 10px;
  z-index: 9999;
  position: fixed;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: ${sizes.mobile + 1}px) {
    width: auto;
    padding: 0;
  }
`;
